export default "__VITE_ASSET__Cen$iMgT__"